// client/src/api/ApiNotifications.js
import flex from './FlexFetch'

const notifications_endpoint = '/api/1.0/notifications/'

/**
 * Get count of unread notifications for the current user
 * @returns {Promise<Object>} Strict response envelope with unread count in data.count
 */
async function getUnreadCount() {
  const response = await flex.flexFetch(
    `${notifications_endpoint}getUnreadCount`,
    {
      credentials: 'include',
    },
  )
  return flex.handleResponse(response)
}

/**
 * Mark a notification as read
 * @param {number} notificationId - The notification ID
 * @returns {Promise<Object>} Strict response envelope
 */
async function markAsRead(notificationId) {
  const response = await flex.flexFetch(`${notifications_endpoint}markAsRead`, {
    method: 'POST',
    body: JSON.stringify({ notificationId }),
    credentials: 'include',
  })
  return flex.handleResponse(response)
}

/**
 * Mark all notifications as read for the current user
 * @returns {Promise<Object>} Strict response envelope with count in data.count
 */
async function markAllAsRead() {
  const response = await flex.flexFetch(
    `${notifications_endpoint}markAllAsRead`,
    {
      method: 'POST',
      credentials: 'include',
    },
  )
  return flex.handleResponse(response)
}

/**
 * Get list of all notifications for the current user
 * @returns {Promise<Object>} Strict response envelope with notifications in data.items
 */
async function getList() {
  const response = await flex.flexFetch(`${notifications_endpoint}list`, {
    credentials: 'include',
  })
  return flex.handleResponse(response)
}

/**
 * Delete a notification
 * @param {number} notificationId - The notification ID
 * @returns {Promise<Object>} Strict response envelope
 */
async function deleteNotification(notificationId) {
  const response = await flex.flexFetch(
    `${notifications_endpoint}deleteNotification`,
    {
      method: 'POST',
      body: JSON.stringify({ notificationId }),
      credentials: 'include',
    },
  )
  return flex.handleResponse(response)
}

const ApiNotifications = {
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  getList,
  deleteNotification,
}

export default ApiNotifications
